export interface AssetsDashboardMap {
  type: string
  id: string
  attributes: {
    name: string
    total_area: number | null
    total_net_rent_yearly: number | null
    vacancy_percent: number | null
    market_value: number | null
    sales_price_net: number | null
    acquisition_price_net: number | null
    asking_price: number | null
    share: number | null
    portfolio_area_share: number | null
    portfolio_rent_share: number | null
  }
}

export const assetsDashboardMapAttributes = [
  "acquisition_price_net",
  "asking_price",
  "market_value",
  "name",
  "portfolio_area_share",
  "portfolio_rent_share",
  "sales_price_net",
  "total_area",
  "total_net_area",
  "total_net_rent_yearly",
  "vacancy_percent",
  "deal_volume",
  "deal_volume_share",
  "total_deals",
  "total_deals_share"
]
